import { RuntimeFeatureFlag } from '@/feature-flags/definitions'
import { useRuntimeFeatureFlag } from '@/feature-flags/useRuntimeFeatureFlag'
import { isValidUuid } from '@/util/is-valid-uuid'
import { Navigate, useLocation, useParams } from 'react-router-dom'
import { matterPaths } from '@/routing/paths'
import AgentV2ChatRoute from '@/routes/dashboard/AgentV2ChatRoute'

/** Legacy shared links follow the runtime decision instead of redirecting before flags load. */
export default function ChatTableRedirect() {
  const { enabled, loading } = useRuntimeFeatureFlag(RuntimeFeatureFlag.TABLES)
  const { matterId, chatId } = useParams()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const tableId = params.get('table')
  if (enabled && !loading && matterId && chatId && tableId && isValidUuid(tableId)) {
    params.delete('table')
    params.delete('draft')
    params.set('chat', chatId)
    return <Navigate replace to={`${matterPaths.table(matterId, tableId)}?${params}${location.hash}`} />
  }
  return <AgentV2ChatRoute />
}
